// Locale bundles are split per feature area so that pages can be worked on
// independently. Every file here must exist in BOTH languages; the parity
// test (localeParity.test.js) compares the merged trees.
import enBase from "./locales/en.json";
import arBase from "./locales/ar.json";
import enShell from "./locales/en/shell.json";
import arShell from "./locales/ar/shell.json";
import enUi from "./locales/en/ui.json";
import arUi from "./locales/ar/ui.json";
import enDashboard from "./locales/en/dashboard.json";
import arDashboard from "./locales/ar/dashboard.json";
import enReports from "./locales/en/reports.json";
import arReports from "./locales/ar/reports.json";
import enUsers from "./locales/en/users.json";
import arUsers from "./locales/ar/users.json";
import enAgencies from "./locales/en/agencies.json";
import arAgencies from "./locales/ar/agencies.json";
import enAirlines from "./locales/en/airlines.json";
import arAirlines from "./locales/ar/airlines.json";
import enCurrencies from "./locales/en/currencies.json";
import arCurrencies from "./locales/ar/currencies.json";
import enAds from "./locales/en/ads.json";
import arAds from "./locales/ar/ads.json";
import enFinance from "./locales/en/finance.json";
import arFinance from "./locales/ar/finance.json";
import enOperations from "./locales/en/operations.json";
import arOperations from "./locales/ar/operations.json";
import enTopups from "./locales/en/topups.json";
import arTopups from "./locales/ar/topups.json";
import enSettings from "./locales/en/settings.json";
import arSettings from "./locales/ar/settings.json";
import enMoney from "./locales/en/money.json";
import arMoney from "./locales/ar/money.json";
import enAirlineCredit from "./locales/en/airlineCredit.json";
import arAirlineCredit from "./locales/ar/airlineCredit.json";

const isPlainObject = (value) =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

export const deepMerge = (target, source) => {
  const output = { ...target };
  Object.entries(source || {}).forEach(([key, value]) => {
    output[key] =
      isPlainObject(value) && isPlainObject(output[key])
        ? deepMerge(output[key], value)
        : value;
  });
  return output;
};

const mergeAll = (bundles) => bundles.reduce((acc, bundle) => deepMerge(acc, bundle), {});

export const en = mergeAll([
  enBase, enShell, enUi, enDashboard, enReports, enUsers, enAgencies,
  enAirlines, enCurrencies, enAds, enFinance, enOperations, enTopups, enSettings, enMoney,
  enAirlineCredit,
]);

export const ar = mergeAll([
  arBase, arShell, arUi, arDashboard, arReports, arUsers, arAgencies,
  arAirlines, arCurrencies, arAds, arFinance, arOperations, arTopups, arSettings, arMoney,
  arAirlineCredit,
]);
